export const marketReportStatus = {
    coming: 0, // initial rendering ， and have not yet obtained data   Right now  coming soon
    noLocation: 1, //   no choice location  condition ， No need to initiate a request ,  that prompts the user to choose location, highest priority 
    loading: 2, //  non-initial rendering ， is loading  data 
    loaded: 3 //  Data successfully requested 
};
export const recentListingStatus = {
    coming: 0, // initial rendering ， and have not yet obtained data   Right now  coming soon
    noLocation: 1, //   no choice location  condition ， No need to initiate a request ,  that prompts the user to choose location, highest priority 
    loading: 2, //  non-initial rendering ， is loading  data 
    loaded: 3 //  Data successfully requested 
};
